<template>
  <div class="industry">
    <div class="industry-left">
      <div class="industry-left-top">
        <div class="industry-box">
          <div class="industry-zsys businessTree">
            <div class="industry-zsys-title">
              <img class="left-img" src="@/assets/images/title-1.png" />
              <div>产业生产总值增速</div>
              <img class="right-img" src="@/assets/images/title-2.png" />
            </div>
            <div
              id="jdt"
              style="width: 100%; height: calc(100% - 0.3rem)"
            ></div>
          </div>
        </div>
      </div>
      <div class="industry-left-right">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">
              <img class="left-img" src="@/assets/images/title-1.png" />
              <div>产业生产总值比重</div>
              <img class="right-img" src="@/assets/images/title-2.png" />
            </div>
            <div
              id="cybz"
              style="width: 100%; height: calc(100% - 0.3rem)"
            ></div>
          </div>
        </div>
      </div>
      <div class="industry-left-right-right">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">
              <img class="left-img" src="@/assets/images/title-1.png" />
              <div>产业生产增速对比</div>
              <img class="right-img" src="@/assets/images/title-2.png" />
            </div>
            <div
              id="cyzs"
              style="width: 100%; height: calc(100% - 0.3rem)"
            ></div>
          </div>
        </div>
      </div>
      <div class="industry-left-right-right">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">
              <img class="left-img" src="@/assets/images/title-1.png" />
              <div>居民消费分类涨幅</div>
              <img class="right-img" src="@/assets/images/title-2.png" />
            </div>
            <div
              id="jmxfxzf"
              style="width: 100%; height: calc(100% - 0.3rem)"
            ></div>
          </div>
        </div>
      </div>
      <div class="industry-left-right-right">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">
              <img class="left-img" src="@/assets/images/title-1.png" />
              <div>居民消费价格增速</div>
              <img class="right-img" src="@/assets/images/title-2.png" />
            </div>
            <div
              id="jmxfjgzs"
              style="width: 100%; height: calc(100% - 0.3rem)"
            ></div>
          </div>
        </div>
      </div>
      <div class="industry-left-right-right">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">
              <img class="left-img" src="@/assets/images/title-1.png" />
              <div>农林牧渔业总产值</div>
              <img class="right-img" src="@/assets/images/title-2.png" />
            </div>
            <div
              id="nlmyyzcz"
              style="width: 100%; height: calc(100% - 0.3rem)"
            ></div>
          </div>
        </div>
      </div>
      <div class="industry-left-bottom-left">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">
              <img class="left-img" src="@/assets/images/title-1.png" />
              <div>消费涨幅</div>
              <img class="right-img" src="@/assets/images/title-2.png" />
            </div>
            <div
              id="zzt3"
              style="width: 100%; height: calc(100% - 0.3rem)"
            ></div>
          </div>
        </div>
      </div>
      <div class="industry-left-bottom-center">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">
              <img class="left-img" src="@/assets/images/title-1.png" />
              <div>产业对比</div>
              <img class="right-img" src="@/assets/images/title-2.png" />
            </div>
            <div
              id="zzt4"
              style="width: 100%; height: calc(100% - 0.3rem)"
            ></div>
          </div>
        </div>
      </div>
      <div class="industry-left-bottom-right">
        <div class="industry-box">
          <div class="industry-zsys">
            <div class="industry-zsys-title">
              <img class="left-img" src="@/assets/images/title-1.png" />
              <div>GDP</div>
              <img class="right-img" src="@/assets/images/title-2.png" />
            </div>
            <div
              id="pie4"
              style="width: 100%; height: calc(100% - 0.3rem)"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <div class="industry-center">
      <div class="total-box">
        <div class="total-item">
          <div class="item-top">地理位置</div>
          <div class="item-text">
            <p style="color: #6ec8e3">宁夏平原中部</p>
            <p style="color: #6ec8e3">黄河中下游</p>
          </div>
          <img src="@/assets/images/zszy_blue.png" />
        </div>
        <div class="total-item">
          <div class="item-top">行政区划</div>
          <div class="item-text">
            <p style="color: #6ec8e3">8镇4乡</p>
          </div>
          <img src="@/assets/images/zszy_blue.png" />
        </div>
        <div class="total-item">
          <div class="item-top">土地面积</div>
          <div class="item-text">
            <p style="color: #6ec8e3">1415平方公里</p>
          </div>
          <img src="@/assets/images/zszy_blue.png" />
        </div>
        <div class="total-item">
          <div class="item-top">耕地面积</div>
          <div class="item-text">
            <p style="color: #6ec8e3">42万亩</p>
          </div>
          <img src="@/assets/images/zszy_blue.png" />
        </div>
        <div class="total-item">
          <div class="item-top">人口数量</div>
          <div class="item-text">
            <p style="color: #6ec8e3">46.1万人</p>
          </div>
          <img src="@/assets/images/zszy_blue.png" />
        </div>
      </div>
      <div class="video-box">
        <video-player
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
          @pause="onPlayerPause($event)"
        ></video-player>
      </div>
      <!-- <div class="center-zsys-title">产业招商链</div> -->
      <!-- <div class="center-zsr">
        招商企业数
        <span v-for="(item,index) in zsqys" :key="index">{{ item }}</span>
        家
      </div>
      <div class="center-xzxx">
        <div class="center-xzxx-item" v-for="(item,index) in xzxxList1" :key="index">
          <div>{{item.name}}</div>
          <div>
            <span>{{item.total}}</span>家
          </div>
        </div>
      </div>
      <div class="center-xzxx2">
        <div class="center-xzxx-item" v-for="(item,index) in xzxxList2" :key="index">
          <div>{{item.title}}</div>
          <div>
            <span>{{item.value}}</span>家
          </div>
        </div>
      </div> -->
      <!-- <div id="map_1" style="width: 100%; height: 100%"></div> -->
      <!--      <mapThree :xzxxList1="xzxxList1" :xzxxList2="xzxxList2" style="width: 100%; height: 100%"></mapThree>-->
    </div>
    <div class="industry-right">
      <div class="right-top-title">重点产业发展情况</div>
      <div class="right-top-content-wrap">
        <div class="right-top-wrap-item">
          <p class="item-title">轻工纺织业</p>
          <p class="item-content">
            企业数量<span>18</span>家，生产总值<span>64</span>亿元
          </p>
        </div>
        <div class="right-top-wrap-item">
          <p class="item-title">粮油加工行业</p>
          <p class="item-content">
            企业数量<span>3</span>家，主要以少武粮油、中桦雪、国海粮油等企业发展富硒大米、面粉、亚麻籽油、小杂粮等特色富硒农产品加工业，同时持续培育壮大龙头企业，提高品牌知名度，突出集群化、绿色化、功能化特色板块发展优势，构建优势突出、功能完善、体系完整的粮油加工行业产业格局。
          </p>
        </div>
        <div class="right-top-wrap-item">
          <p class="item-title">数字信息企业</p>
          <p class="item-content">
            企业数量<span>7</span>家，生产总值<span>1</span>亿元。培育打造了恒丰纺织行业级互联网云平台（全区第一家），形成了传统产业自动化、数字化、智能化改造成熟案例。
          </p>
        </div>
        <div class="right-top-wrap-item">
          <p class="item-title">清洁能源产业</p>
          <p class="item-content">
            截至目前，建成三峡新能源五里坡兆瓦光伏发<span>200</span>电项目、天净五里坡<span>99</span>兆瓦风力发电项目、宁夏昊泽润奇牧场<span>5.1</span>兆瓦分布式光伏发电项目等清洁能源发电项目<span>16</span>个，总装机容量达<span>877</span>兆瓦，其中集中式光伏<span>550</span>兆瓦，分布式光伏<span>39</span>兆瓦，风力发电<span>288</span>兆瓦。建成宁储板桥、宁储同利、达储科技同利等储能电站<span>4</span>座，总储能规模达<span>500</span>兆瓦/<span>1000</span>兆瓦时。
          </p>
        </div>
        <div class="right-top-wrap-item">
          <p class="item-title">装备制造产业</p>
          <p class="item-content">
            截止2022年底，全区共有装备制造企业<span>13</span>家，规上企业<span>5</span>家，装备制造企业完成产值<span>2</span>亿元。
          </p>
        </div>
        <div class="right-top-wrap-item">
          <p class="item-title">奶产业</p>
          <p class="item-content">
            截至2022年年末，全区共有规模化奶牛养殖场<span>103</span>家，奶牛存栏<span>24</span>万头，鲜奶产量<span>24</span>万吨，泌乳牛平均单产<span>9.5</span>吨，鲜奶乳蛋白含量<span>3.3</span>g/<span>100</span>ml，乳脂率达到<span>3.6%</span>，规模化养殖比重达到<span>98％</span>以上，养殖粪污综合利用率达到<span>95%</span>，产品监督抽检合格率达到<span>100%</span>以上。全区共有乳品加工企业<span>6</span>家，2022年<span>6</span>家乳品企业产值达到<span>113</span>亿元。
          </p>
        </div>
        <div class="right-top-wrap-item">
          <p class="item-title">冷凉蔬菜产业</p>
          <p class="item-content">
            2022年，利通区冷凉蔬菜种植面积<span>95120</span>亩。其中日光温室种植面积<span>9606</span>亩，拱棚瓜菜种植面积<span>9923.6</span>亩，露地蔬菜种植面积<span>16189</span>亩，供港蔬菜种植面积<span>45930.6</span>亩，秋复菜种植面积<span>13470.8</span>亩。冷凉蔬菜产业形成了以设施瓜菜为主体，露地蔬菜为补充的生产体系，基本实现了全年生产，均衡供应。
          </p>
        </div>
        <div class="right-top-wrap-item">
          <p class="item-title">肉牛肉羊产业</p>
          <p class="item-content">
            截至2022年年末，全区共有规模化肉牛养殖场<span>93</span>家，规模化肉羊场<span>6</span>家，肉牛存栏<span>11.5</span>万头，饲养量<span>18.7</span>万头，肉羊存栏<span>27.2</span>万只，饲养量<span>61.1</span>万只。全区共有肉制品屠宰、加工企业<span>4</span>家。
          </p>
        </div>
      </div>
    </div>
    <!-- 招商企业详情 -->
    <div v-if="companyBox">
      <companyDetail :form="form" @handleClose="handleClose"></companyDetail>
    </div>
    <img
      ref="mapSvgAreaMap"
      id="mapSvg"
      v-show="false"
      hidden
      style="width: 500px; height: 500px"
      src="../assets/images/map_1.png"
    />
  </div>
</template>

<script>
// import countTo from "vue-count-to";
import * as echarts from "echarts";
// import "echarts-gl";
import { directive } from "vue-awesome-swiper";
// import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";
import Swiper2, { Navigation, Pagination, Autoplay } from "swiper";
Swiper2.use([Navigation, Pagination, Autoplay]);
import ltqMap from "@/assets/json/ltq.json";
import api from "@/api/api";
import companyDetail from "@/components/companyDetail";
// import mapThree from "@/components/mapThree.vue";
export default {
  name: "industryChain",
  components: {
    // countTo,
    // Swiper,
    // SwiperSlide,
    companyDetail,
    // mapThree
  },
  directives: {
    swiper: directive,
  },
  data() {
    return {
      myChart: null,
      myChart2: null,
      myChart3: null,
      myChart4: null,
      myChart5: null,
      config: {},
      swiperOptions2: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          stopOnLastSlide: true,
        },
      },
      statistics: {
        areaCount: 0,
        articleConut: 0,
        doctorCount: 0,
        facilitiesCount: 0,
        foodCount: 0,
        healthCount: 0,
        industryCount: 0,
        nongjialeCount: 0,
        nursingCount: 0,
        productCount: 0,
        viewCount: 0,
        hospitalCount: 0,
        healthPercent: 1,
        nursingPercent: 1,
        facilitiesPercent: 1,
        hospitalPercent: 1,
      },
      articleConfig: {},
      zsqys: "0024",
      xzxxList1: [],
      xzxxList2: [],
      companyBox: false,
      form: {},
      myChart6: null,
      myChart7: null,
      myChart8: null,
      myChart9: null,
      titleList: [
        { name: "其他业务", number: 25000 },
        { name: "社会业务", number: 35000 },
        { name: "主业业务", number: 50000 },
      ],
      myChart10: null,
      myChart11: null,
      myChart12: null,
      myChart13: null,
      myChart14: null,
      playerOptions: {
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/mp4",
            src: "/video/jjvideo1.mp4",
          },
        ],
        poster: require("@/assets/images/video-img.png"), //你的封面地址
        width: document.documentElement.clientWidth,
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          fullscreenToggle: true, //全屏按钮
        },
      },
    };
  },
  mounted() {
    // this.initChart();
    // this.createMap();
    this.getStatisticsRegularCount();
    // this.getMerchantList();
    // this.getArticleList();
    // this.getJtysList();
    // this.getVideoList();
    // this.getLtMerchantCount();
  },
  methods: {
    onPlayerPause() {
      let vm = this;
      vm.playerOptions.sources.src = "";
    },
    //获取视频地址
    getVideoList() {
      // this.playerOptions.poster = img;
      this.playerOptions.sources[0].src = "../assets/images/jjvideo.mp4";
      this.playerShow = true;
      // api.getVideoList().then((res) => {
      //   if (res.rows && res.rows.length > 0) {
      //     let src = "http://119.60.27.99:9001/prod-api" + res.rows[0].video;
      //     let img = "http://119.60.27.99:9001/prod-api" + res.rows[0].faceImg;
      //     console.log(src, img);
      //     this.playerOptions.poster = img;
      //     this.playerOptions.sources[0].src = src;
      //     this.playerShow = true;
      //   }
      // });
    },
    getLtMerchantCount() {
      api.getLtMerchantCount().then((res) => {
        if (res.data.length <= 5) {
          this.xzxxList1 = res.data;
          this.xzxxList2 = [];
        } else {
          this.xzxxList1 = res.data.splice(0, 5);
          this.xzxxList2 = res.data.splice(5, res.data.length);
        }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.companyBox = false;
    },
    // 招商政策
    skipto(config) {
      this.form = this.tableList[config.rowIndex];
      this.companyBox = true;
    },
    getMerchantList() {
      api.getMerchantList().then((res) => {
        this.config = {
          align: ["left", "center", "right"],
          oddRowBGC: "transparent",
          evenRowBGC: "transparent",
          data: res.rows.map((item) => {
            return [item.firmName, item.firmTypeName, item.address];
          }),
        };
        this.tableList = res.rows;
        let total = "";
        if (String(res.total).length === 1) {
          total = "000" + res.total;
        } else if (String(res.total).length === 2) {
          total = "00" + res.total;
        } else if (String(res.total).length === 3) {
          total = "0" + res.total;
        } else {
          total = "" + res.total;
        }
        this.zsqys = total;
      });
    },
    getArticleList() {
      api.getArticleList().then((res) => {
        this.articleConfig = {
          align: ["left", "right"],
          oddRowBGC: "transparent",
          evenRowBGC: "transparent",
          data: res.rows.map((item) => {
            return [item.title, item.publishTime];
          }),
        };
      });
    },

    getJtysList() {
      api.getLtDoctorCount().then((res) => {
        let addressList = [];
        // let notSign = [];
        console.log(res.data);
        res.data.forEach((item) => {
          addressList.push({
            name: item.name,
            value: Number(item.isSignTotal),
            // name: item.name + '(' + (Number(item.isSignTotal) + Number(item.noSignTotal)) + '人)'
          });
        });
        // notSign
        // this.initJtysChart(addressList);
      });
    },
    // 家庭医生 图表
    // notSign
    initJtysChart(addressList) {
      // let winWidth = window.innerWidth;
      const that = this;
      that.myChart4 = echarts.init(document.getElementById("jtys"));
      let option = {
        color: [
          "#00d1d1",
          "#529fcf",
          "#71d0aa",
          "#c5ff7d",
          "#c57dff",
          "#ff7db7",
          "#ffaf7d",
          "#7dffd8",
          "#7d7fff",
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          // type: 'scroll',
          // orient: 'vertical',
          right: 10,
          top: 10,
          bottom: 20,
          textStyle: {
            color: "#cdfbff",
          },
          data: addressList.map((item) => item.name),
        },
        grid: {
          top: "0%",
        },
        series: [
          {
            name: "已签约医生",
            type: "pie",
            radius: ["30%", "50%"],
            center: ["50%", "60%"],
            // avoidLabelOverlap: true,
            startAngle: 180,
            label: {
              color: "#cdfbff",
              show: true,
              formatter(param) {
                // correct the percentage
                return (
                  param.name +
                  " (" +
                  param.value +
                  "人," +
                  param.percent * 2 +
                  "%)"
                );
              },
            },
            labelLine: {
              show: true,
            },
            itemStyle: {
              borderRadius: 10,
              borderColor: "#010B49",
              borderWidth: 3,
            },
            data: addressList,
          },
        ],
      };
      that.myChart4.setOption(option);
    },
    getStatisticsRegularCount() {
      // api.getStatisticsRegularCount().then((res) => {
      //   for (let item in res.data) {
      //     res.data[item] = Number(res.data[item]);
      //   }
      //   let count =
      //     Number(res.data.healthCount) +
      //     Number(res.data.nursingCount) +
      //     Number(res.data.facilitiesCount) +
      //     Number(res.data.hospitalCount);
      //   res.data.countPercent = count;
      //   res.data.healthPercent = (
      //     (res.data.healthCount / res.data.countPercent) * 1.4 +
      //     1
      //   ).toFixed(2);
      //   res.data.nursingPercent = (
      //     (res.data.nursingCount / res.data.countPercent) * 1.4 +
      //     1
      //   ).toFixed(2);
      //   res.data.facilitiesPercent = (
      //     (res.data.facilitiesCount / res.data.countPercent) * 1.4 +
      //     1
      //   ).toFixed(2);
      //   res.data.hospitalPercent = (
      //     (res.data.hospitalCount / res.data.countPercent) * 1.4 +
      //     1
      //   ).toFixed(2);
      //   console.log(res.data);
      //   this.statistics = res.data;

      // });
      // this.initWzltChart();
      // this.initTrapezoid();
      // this.initCirtic();
      this.initLine();
      this.initpie();
      this.initpie2();
      this.initpie3();
      this.initBar1();
      this.initBar2();
      this.initBar3();
      this.initBar4();
      this.initPie4();
    },
    // 玫瑰图
    initPie4() {
      const that = this;
      that.myChart14 = echarts.init(document.getElementById("pie4"));
      let option = {
        backgroundColor: "#03213D", //背景色
        title: {
          text: "",
          left: "center",
          top: 20,
          textStyle: {
            color: "#ccc",
          },
        },
        tooltip: {
          trigger: "item",
        },
        visualMap: {
          show: false,
          min: 80,
          max: 600,
          inRange: {
            colorLightness: [0, 1],
          },
        },
        series: [
          {
            name: "GDP",
            type: "pie",
            radius: "55%",
            avoidLabelOverlap: false,

            center: ["50%", "50%"],
            data: [
              { value: 335, name: "生活相关" },
              { value: 310, name: "旅游娱乐" },
              { value: 274, name: "衣食住行" },
              { value: 235, name: "游戏畅玩" },
            ].sort(function (a, b) {
              return a.value - b.value;
            }),
            roseType: "radius",
            label: {
              color: "rgba(255, 255, 255, 0.3)",
            },
            labelLine: {
              minTurnAngle: 0,
              lineStyle: {
                color: "rgba(255, 255, 255, 0.3)",
              },
              smooth: 0.2,
              length: 1,
              length2: 1,
            },
            itemStyle: {
              color: "#00E2FD",
              shadowBlur: 200,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
            animationType: "scale",
            animationEasing: "elasticOut",
            animationDelay: function () {
              return Math.random() * 200;
            },
          },
        ],
      };
      that.myChart14.setOption(option);
    },
    // 柱状图4
    initBar4() {
      const that = this;
      that.myChart13 = echarts.init(document.getElementById("nlmyyzcz"));
      const basicColors = [
        ["#ABDCFF", "#0396FF"],
        ["#90F7EC", "#32CCBC"],
        ["#FFF6B7", "#F6416C"],
        ["#E2B0FF", "#9F44D3"],
        ["#43CBFF", "#9870CC"],
        ["#FCCF31", "#F55555"],
        ["#F761A1", "#8C1BAB"],
        ["#81FBB8", "#28C76F"],
      ];
      let option = {
        backgroundColor: "#03213D",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "20%",
          bottom: "1%",
          containLabel: true,
        },

        xAxis: {
          type: "category",
          data: ["2018年", "2019年", "2020年", "2021年", "2022年", "2023年"],
          axisTick: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#BDD8FB",
              width: 1, // 这里是为了突出显示加上的
            },
          },
          axisLabel: {
            textStyle: {
              color: "#BDD8FB",
              fontSize: 12,
            },
          },
        },

        yAxis: {
          type: "value",
          axisLine: {
            show: false,
            lineStyle: {
              color: "white",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "rgba(255, 255, 255, 0.15)",
            },
          },
          axisLabel: {
            textStyle: {
              color: "#BDD8FB",
            },
          },
        },

        series: [
          {
            name: "农林牧渔业总产值",
            type: "bar",
            barWidth: "25%",
            itemStyle: {
              normal: {
                color: this.genLinearGradient(basicColors[6]),
                barBorderRadius: 12,
              },
            },
            data: [43.1, 46.4, 51.2, 61.9, 65.1, 65.7],
          },
          {
            name: "农林牧渔业增加值",
            type: "bar",
            barWidth: "25%",
            itemStyle: {
              normal: {
                color: this.genLinearGradient(basicColors[1]),
                barBorderRadius: 11,
              },
            },
            data: [22.5, 24.1, 26.1, 31.5, 33.2, 33.6],
          },
        ],
      };

      that.myChart13.setOption(option);
    },
    // 柱状图3
    initBar3() {
      const that = this;
      that.myChart12 = echarts.init(document.getElementById("zzt3"));
      const datas = [
        { name: "零售餐饮", value: "264.9" },
        { name: "房地产", value: "241.5" },
        { name: "公共设施", value: "312.5" },
        { name: "教育", value: "447.9" },
        { name: "公共管理", value: "147.9" },
      ];
      const myColor = ["#60F7F8", "#60F7F8", "#60F7F8", "#60F7F8"].reverse();
      const xData = datas.map((item) => item.name);
      const yData = datas.map((item) => item.value);
      const max = Math.ceil(Math.max(...yData) * 1.2);
      const maxData = [max, max, max, max, max];
      let option = {
        backgroundColor: "#03213D",
        grid: {
          left: "55%",
          right: "8%",
          bottom: "5%",
          top: "0%",
          containLabel: false,
        },
        xAxis: [
          {
            show: false,
          },
          {
            show: false,
          },
        ],
        yAxis: [
          {
            show: false,
            inverse: true,
            data: yData,
          },
          {
            show: false,
            data: yData,
            offset: -35,
            position: "right",
            axisLabel: {
              lineHeight: 5,
              verticalAlign: "bottom",
              fontSize: 12,
              color: "#fff",
              formatter: "{value}亿",
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },
        ],
        series: [
          {
            name: "进度",
            show: true,
            type: "bar",
            barGap: "-100%",
            xAxisIndex: 1,
            barWidth: 4,
            itemStyle: {
              borderRadius: 10,
              color: (params) => {
                var num = myColor.length;
                return {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#0F1F45",
                    },
                    {
                      offset: 1,
                      color: myColor[params.dataIndex % num],
                    },
                  ],
                };
              },
            },
            label: {
              show: false,
            },
            // max: 0,
            labelLine: {
              show: false,
            },
            z: 2,
            data: yData,
            animationDelay: 1000,
            animationDuration: 1000,
          },
          {
            name: "外圆",
            type: "scatter",
            emphasis: {
              scale: false,
            },
            xAxisIndex: 1,
            symbolSize: 10,
            itemStyle: {
              color: (params) => {
                var num = myColor.length;
                return myColor[params.dataIndex % num];
              },
              shadowColor: "rgba(255, 255, 255, 0.5)",
              shadowBlur: 5,
              borderWidth: 1,
              opacity: 1,
            },
            z: 2,
            data: yData,
            animationDelay: 1500,
            animationDuration: 1000,
          },
          {
            name: "年份",
            z: 1,
            show: true,
            type: "bar",
            xAxisIndex: 1,
            barGap: "-100%",
            barWidth: 4,
            itemStyle: {
              borderRadius: 4,
              color: "rgba(13, 55, 78, 1)",
            },
            label: {
              show: true,
              verticalAlign: "middle",
              position: "left",
              fontSize: 14,
              color: "#fff",
              formatter: function (data) {
                return xData[data.dataIndex] + "：";
              },
            },
            data: maxData,
          },
        ],
      };
      that.myChart12.setOption(option);
    },
    // 柱状图2
    initBar2() {
      const that = this;
      that.myChart11 = echarts.init(document.getElementById("jmxfjgzs"));

      let option = {
        backgroundColor: "#03213D",
        title: {
          left: "center",
          bottom: "5%",
          textStyle: {
            color: "#fff",
            fontSize: 12,
          },
        },
        grid: {
          left: "1%",
          right: "1%",
          top: "20%",
          bottom: "1%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [
            "1-3月",
            "1-4月",
            "1-5月",
            "1-6月",
            "1-7月",
            "1-8月",
            "1-9月",
            "1-10月",
            "1-11月",
            "1-12月",
          ],
          axisLabel: {
            margin: 30,
            color: "#ffffff63",
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: true,
            length: 25,
            lineStyle: {
              color: "#ffffff1f",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#ffffff1f",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            position: "right",
            axisLabel: {
              margin: 20,
              color: "#ffffff63",
            },

            axisTick: {
              show: true,
              length: 15,
              lineStyle: {
                color: "#ffffff1f",
              },
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#ffffff1f",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#fff",
                width: 2,
              },
            },
          },
        ],
        series: [
          {
            name: "注册总量",
            type: "line",
            smooth: true, //是否平滑曲线显示
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 6,
            lineStyle: {
              normal: {
                color: "#fff", // 线条颜色
              },
            },
            label: {
              show: true,
              position: "top",
              textStyle: {
                color: "#fff",
              },
            },
            itemStyle: {
              color: "red",
              borderColor: "#fff",
              borderWidth: 3,
            },
            tooltip: {
              show: false,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#eb64fb",
                    },
                    {
                      offset: 1,
                      color: "#3fbbff0d",
                    },
                  ],
                  false
                ),
              },
            },
            data: [1.1, 0.8, 0.7, 0.6, 0.6, 0.6, 0.6, 0.5, 0.4, 0.4],
          },
        ],
      };

      that.myChart11.setOption(option);
    },
    // 柱状图1
    initBar1() {
      const that = this;
      that.myChart10 = echarts.init(document.getElementById("jmxfxzf"));
      let option = {
        backgroundColor: "#03213D", //背景色
        grid: {
          left: "1%",
          right: "1%",
          top: "20%",
          bottom: "1%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            lineStyle: {
              color: "rgba(255,255,255,0.7)",
            },
          },
          backgroundColor: "rgba(255,255,255,0.1)",
          padding: [5, 5],
          textStyle: {
            color: "rgb(255,255,255)",
          },
        },
        legend: {
          x: "center",
          y: "25",
          icon: "circle",
          itemWidth: 2,
          itemHeight: 2,
          itemGap: 1,
          textStyle: {
            color: "#C0C4CC",
            fontSize: 12,
            fontWeight: "bold",
          },
          data: ["收入", "支出"],
        },
        xAxis: {
          type: "category",
          data: [
            "其他用品和服务",
            "医疗保健",
            "教育文化和娱乐",
            "生活用品和服务",
            "居住",
            "衣着",
            "食品烟酒",
          ],
          boundaryGap: true,
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          // type: 'dashed',
          axisLine: {
            lineStyle: {
              type: "dashed",
              color: "#2557B4",
            },
          },
          axisLabel: {
            margin: 2,
            textStyle: {
              fontSize: 12,
              color: "#C0C4CC",
            },
          },
        },
        yAxis: [
          {
            type: "value",
            position: "right",
            name: "单位：%",
            nameTextStyle: {
              padding: [0, 50, 0, 0],
              color: "#C0C4CC",
              fontSize: 12,
              fontWeight: "bold",
              // lineHeight: 40,
            },
            splitLine: {
              show: true,
              lineStyle: {
                type: "dashed",
                color: "#C0C4CC",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(255,255,255,0.3)",
              },
            },

            axisLabel: {
              show: false,
              margin: 2,
              textStyle: {
                fontSize: 12,
                color: "#DEEBFF",
              },
            },
          },
        ],
        series: [
          {
            name: "收入",
            type: "line",
            smooth: true,
            showSymbol: false,
            symbol: "circle",
            // showSymbol: true,
            // symbol: 'circle',
            data: [2.6, 0.9, 2.2, 0.1, 0, 0.6, 1.6],
            itemStyle: {
              normal: {
                color: "#287CE8",
              },
            },
            lineStyle: {
              normal: {
                width: 3,
              },
            },
            markLine: {
              name: "aa",
              // symbol: ['image://' + arrowBj],
              symbolSize: [12, 6],
              lineStyle: {
                type: "dashed",
                color: "#287CE8",
              },
            },
            markPoint: {
              symbol: "circle",
              symbolSize: [14, 14], // 容器大小
              symbolOffset: ["0%", "0%"],
              data: [
                {
                  name: "最大值",
                  type: "max",
                  valueIndex: 1,
                },
              ],
              label: {
                show: true,
                position: "top",
                fontSize: 14,
                color: "#287CE8",
              },
            },
          },
          {
            name: "支出",
            type: "line",
            smooth: true,
            showSymbol: false,
            symbol: "circle",
            symbolSize: 6,
            data: [0, 0, 0, -2.0, 0, -0.7, 0, 0],
            itemStyle: {
              normal: {
                color: "#38FFBA",
              },
            },
            lineStyle: {
              normal: {
                width: 3,
              },
            },
            markLine: {
              name: "aa",
              // symbol: ['image://' + arrowGz],
              symbolSize: [12, 6],
              lineStyle: {
                type: "dashed",
                color: "#287CE8",
              },
            },
            markPoint: {
              symbol: "circle",
              symbolSize: [14, 14], // 容器大小
              symbolOffset: ["0%", "0%"],
              data: [
                {
                  name: "最大值",
                  type: "max",
                  valueIndex: 1,
                },
              ],
              label: {
                show: true,
                position: "top",
                fontSize: 14,
                color: "#38FFBA",
              },
            },
          },
        ],
      };
      that.myChart10.setOption(option);
    },
    // 2018-2023年地区生产总值增速图
    initpie() {
      const that = this;
      that.myChart7 = echarts.init(document.getElementById("jdt"));
      let option = {
        backgroundColor: "#03213D",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          top: "30%",
          left: "2%",
          right: "10%",
          bottom: "5%",
          containLabel: true,
        },
        legend: {
          icon: "rect",
          right: "0%",
          top: "2%",
          itemWidth: 2, // 设置宽度
          itemHeight: 7, // 设置高度
          itemGap: 5, // 设置间距
          textStyle: {
            //图例文字的样式
            color: "#89BFE5",
            fontSize: 10,
          },
        },
        xAxis: {
          boundaryGap: true,
          data: ["2018年", "2019年", "2020年", "2021年", "2022年", "2023年"],
          axisLine: {
            lineStyle: {
              color: "rgba(117, 168, 202, 0.4)",
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#fff",
          },
        },
        yAxis: [
          {
            name: "单位：亿元",
            type: "value",
            inverse: false,
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(117, 168, 202, 0.3)",
                type: "dashed",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "#0A5C95",
              },
            },
            axisLabel: {
              formatter: "{value}",
              textStyle: {
                color: "#89BFE5",
                fontSize: 12,
              },
            },
            nameTextStyle: {
              color: "#89BFE5",
              padding: [0, 0, 0, 15],
              fontSize: 12,
            },
            axisTick: {
              show: false,
            },
          },
        ],

        series: [
          {
            name: "",
            type: "line",
            symbol: "circle", //设定为实心点
            showAllSymbol: true,
            symbolSize: 0,
            smooth: true,
            itemStyle: {
              normal: {
                color: `#FFDF04`,
                lineStyle: {
                  //线的颜色
                  color: `#FFDF04`,
                  width: 1.5,
                },
                areaStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "rgba(255, 223, 4, 0.2)",
                      },
                      {
                        offset: 1,
                        color: "rgba(255, 223, 4, 0.1)",
                      },
                    ],
                  },
                },
              },
            },
            data: [197.9, 193.32, 200.65, 239.61, 254.96, 262.49],
          },
        ],
      };

      that.myChart7.setOption(option);
    },
    // 进度图
    initpie2() {
      const that = this;
      const basicColors = [
        ["#ABDCFF", "#0396FF"],
        ["#90F7EC", "#32CCBC"],
        ["#FFF6B7", "#F6416C"],
        ["#E2B0FF", "#9F44D3"],
        ["#43CBFF", "#9708CC"],
        ["#FCCF31", "#F55555"],
        ["#F761A1", "#8C1BAB"],
        ["#81FBB8", "#28C76F"],
      ];
      that.myChart8 = echarts.init(document.getElementById("cybz"));
      let option = {
        backgroundColor: "#03213D",
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          textStyle: {
            fontSize: 12,
            color: "#6A93B9",
            height: 8,
            rich: {
              a: {
                verticalAlign: "bottom",
              },
            },
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            axisLine: {
              lineStyle: {
                color: "#BDD8FB",
                fontSize: 12,
              },
            },
            axisLabel: {
              // interval:0,
              color: "#BDD8FB",
              fontSize: 12,
            },
            axisTick: {
              show: false,
            },
            type: "category",
            data: ["2018年", "2019年", "2020年", "2021年", "2022年", "2023年"],
          },
        ],
        yAxis: [
          {
            type: "value",
            nameTextStyle: {
              fontSize: 12,
              color: "#BDD8FB",
              align: "center",
            },
            splitLine: {
              lineStyle: {
                color: "rgba(255, 255, 255, 0.15)",
                // type: 'dashed', // dotted 虚线
              },
            },
            axisLine: {
              show: true,
            },
            axisTick: {
              show: true,
            },
            axisLabel: {
              fontSize: 12,
              fontFamily: "Bebas",
              color: "#BDD8FB",
            },
          },
        ],
        series: [
          {
            name: "第一产业",
            type: "bar",
            stack: "Ad",
            barWidth: 10,
            data: [190, 132, 101, 134, 90, 230, 210],
            itemStyle: {
              color: this.genLinearGradient(basicColors[0]),
              barBorderRadius: 10,
            },
          },

          {
            name: "第二产业",
            type: "bar",
            stack: "Ad",
            barWidth: 10,
            data: [150, 232, 201, 154, 190, 330, 410],
            itemStyle: {
              color: this.genLinearGradient(basicColors[2]),
              barBorderRadius: 10,
            },
          },

          {
            name: "第三产业",
            type: "bar",
            barWidth: 10,
            stack: "Search Engine",
            data: [120, 132, 101, 234, 190, 130, 120],
            itemStyle: {
              color: this.genLinearGradient(basicColors[3]),
              barBorderRadius: 10,
            },
          },
        ],
      };

      that.myChart8.setOption(option);
    },
    // 生成渐变色
    genLinearGradient(colors) {
      const color = {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          {
            offset: 0,
            color: colors[0], // 0%处的颜色
          },
          {
            offset: 1,
            color: colors[1], // 100%处的颜色
          },
        ],
        global: false,
      };
      return color;
    },
    // 进度图
    initpie3() {
      const that = this;
      that.myChart9 = echarts.init(document.getElementById("cyzs"));
      let option = {
        title: {
          text: "产业生产增速对比",
          x: "center",
          y: 0,
          textStyle: {
            color: "#B4B4B4",
            fontSize: 12,
            fontWeight: "normal",
          },
        },
        backgroundColor: "#03213D",
        tooltip: {
          trigger: "axis",
          backgroundColor: "rgba(255,255,255,0.1)",
          axisPointer: {
            type: "shadow",
            label: {
              show: false,
              backgroundColor: "#7B7DDC",
            },
          },
        },
        legend: {
          data: ["第一产业", "第二产业", "第三产业"],
          textStyle: {
            color: "#B4B4B4",
          },
          top: "7%",
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          data: ["2018年", "2019年", "2020年", "2021年", "2022年", "2023年"],
          axisLine: {
            lineStyle: {
              color: "#B4B4B4",
            },
          },
          axisTick: {
            show: false,
          },
        },
        yAxis: [
          {
            splitLine: { show: false },
            axisLine: {
              lineStyle: {
                color: "#B4B4B4",
              },
            },

            axisLabel: {
              formatter: "{value} ",
            },
          },
          {
            show: false,
            splitLine: { show: false },
            axisLine: {
              lineStyle: {
                color: "#B4B4B4",
              },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          },
        ],

        series: [
          {
            name: "第一产业",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: 8,
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#F02FC2",
              },
            },
            data: [4.0, 3.4, 3.7, 6.5, 4.6, 9.2],
          },
          {
            name: "第二产业",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: 8,
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#956FD4",
              },
            },
            data: [4.1, 4.0, 3.0, 6.5, 11.8, -0.3, 2.6],
          },
          {
            name: "第三产业",
            type: "line",
            smooth: true,
            showAllSymbol: true,
            symbol: "emptyCircle",
            symbolSize: 2,
            yAxisIndex: 1,
            itemStyle: {
              normal: {
                color: "#3EACE5",
              },
            },
            data: [9.2, 6.9, 1.9, 6.3, 1.6, 7.0],
          },
          {
            name: "第一产业",
            type: "bar",
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: 5,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#956FD4" },
                  { offset: 1, color: "#3EACE5" },
                ]),
              },
            },
            data: [4.0, 3.4, 3.7, 6.5, 4.6, 9.2],
          },

          {
            name: "第二产业",
            type: "bar",
            barGap: "-100%",
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: 5,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(156,107,211,0.5)" },
                  { offset: 0.2, color: "rgba(156,107,211,0.3)" },
                  { offset: 1, color: "rgba(156,107,211,0)" },
                ]),
              },
            },
            z: -12,

            data: [4.1, 4.0, 3.0, 6.5, 11.8, -0.3, 2.6],
          },
          {
            name: "第三产业",
            type: "bar",
            barGap: "-100%",
            barWidth: 10,
            itemStyle: {
              normal: {
                barBorderRadius: 5,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(156,107,211,0.5)" },
                  { offset: 0.2, color: "rgba(156,107,211,0.3)" },
                  { offset: 1, color: "rgba(156,107,211,0)" },
                ]),
              },
            },
            z: -12,

            data: [9.2, 6.9, 1.9, 6.3, 1.6, 7.0],
          },
        ],
      };

      that.myChart9.setOption(option);
    },
    // 折线图
    initLine() {
      const that = this;
      that.myChart6 = echarts.init(document.getElementById("zzt4"));
      let option = {
        backgroundColor: "#03213D", //背景色
        color: ["#80FFA5", "#00DDFF"],

        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            boundaryGap: false,
            data: ["电商", "传统", "餐饮", "服装", "商超", "生活", "旅游"],
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: "",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(128, 255, 165)",
                },
                {
                  offset: 1,
                  color: "rgb(1, 191, 236)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: [140, 232, 101, 264, 90, 340, 250],
          },
          {
            name: "",
            type: "line",
            stack: "Total",
            smooth: true,
            lineStyle: {
              width: 0,
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgb(0, 221, 255)",
                },
                {
                  offset: 1,
                  color: "rgb(77, 119, 255)",
                },
              ]),
            },
            emphasis: {
              focus: "series",
            },
            data: [120, 282, 111, 234, 220, 340, 310],
          },
        ],
      };
      that.myChart6.setOption(option);
    },
    // 圆点图
    initCirtic() {
      const that = this;
      that.myChart5 = echarts.init(document.getElementById("ydt"));
      const data = [
        [
          [28604, 77, 17096869, "Australia", 1990],
          [31163, 77.4, 27662440, "Canada", 1990],
          [1516, 68, 1154605773, "China", 1990],
          [13670, 74.7, 10582082, "Cuba", 1990],
          [28599, 75, 4986705, "Finland", 1990],
          [29476, 77.1, 56943299, "France", 1990],
          [31476, 75.4, 78958237, "Germany", 1990],
          [28666, 78.1, 254830, "Iceland", 1990],
          [1777, 57.7, 870601776, "India", 1990],
          [29550, 79.1, 122249285, "Japan", 1990],
          [2076, 67.9, 20194354, "North Korea", 1990],
          [12087, 72, 42972254, "South Korea", 1990],
          [24021, 75.4, 3397534, "New Zealand", 1990],
          [43296, 76.8, 4240375, "Norway", 1990],
          [10088, 70.8, 38195258, "Poland", 1990],
          [19349, 69.6, 147568552, "Russia", 1990],
          [10670, 67.3, 53994605, "Turkey", 1990],
          [26424, 75.7, 57110117, "United Kingdom", 1990],
          [37062, 75.4, 252847810, "United States", 1990],
        ],
        [
          [44056, 81.8, 23968973, "Australia", 2015],
          [43294, 81.7, 35939927, "Canada", 2015],
          [13334, 76.9, 1376048943, "China", 2015],
          [21291, 78.5, 11389562, "Cuba", 2015],
          [38923, 80.8, 5503457, "Finland", 2015],
          [37599, 81.9, 64395345, "France", 2015],
          [44053, 81.1, 80688545, "Germany", 2015],
          [42182, 82.8, 329425, "Iceland", 2015],
          [5903, 66.8, 1311050527, "India", 2015],
          [36162, 83.5, 126573481, "Japan", 2015],
          [1390, 71.4, 25155317, "North Korea", 2015],
          [34644, 80.7, 50293439, "South Korea", 2015],
          [34186, 80.6, 4528526, "New Zealand", 2015],
          [64304, 81.6, 5210967, "Norway", 2015],
          [24787, 77.3, 38611794, "Poland", 2015],
          [23038, 73.13, 143456918, "Russia", 2015],
          [19360, 76.5, 78665830, "Turkey", 2015],
          [38225, 81.4, 64715810, "United Kingdom", 2015],
          [53354, 79.1, 321773631, "United States", 2015],
        ],
      ];
      let option = {
        backgroundColor: new echarts.graphic.RadialGradient(0.3, 0.3, 0.8, [
          // {
          //   offset: 0,
          //   color: '#f7f8fa'
          // },
          // {
          //   offset: 1,
          //   color: '#cdd0d5'
          // }
        ]),
        title: {
          text: "",
          left: "5%",
          top: "3%",
        },
        legend: {
          right: "10%",
          top: "3%",
          data: ["1990", "2015"],
        },
        grid: {
          left: "8%",
          top: "10%",
        },
        xAxis: {
          splitLine: {
            show: false,
            lineStyle: {
              type: "dashed",
            },
          },
        },
        yAxis: {
          splitLine: {
            lineStyle: {
              type: "dashed",
            },
          },
          scale: true,
        },
        series: [
          {
            name: "1990",
            data: data[0],
            type: "scatter",
            symbolSize: function (data) {
              return Math.sqrt(data[2]) / 10e2;
            },
            emphasis: {
              focus: "series",
              label: {
                show: true,
                formatter: function (param) {
                  return param.data[3];
                },
                position: "top",
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(120, 36, 50, 0.5)",
              shadowOffsetY: 5,
              color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                {
                  offset: 0,
                  color: "rgb(251, 118, 123)",
                },
                {
                  offset: 1,
                  color: "rgb(204, 46, 72)",
                },
              ]),
            },
          },
          {
            name: "2015",
            data: data[1],
            type: "scatter",
            symbolSize: function (data) {
              return Math.sqrt(data[2]) / 18e2;
            },
            emphasis: {
              focus: "series",
              label: {
                show: true,
                formatter: function (param) {
                  return param.data[3];
                },
                position: "top",
              },
            },
            itemStyle: {
              shadowBlur: 10,
              shadowColor: "rgba(25, 100, 150, 0.5)",
              shadowOffsetY: 5,
              color: new echarts.graphic.RadialGradient(0.4, 0.3, 1, [
                {
                  offset: 0,
                  color: "rgb(129, 227, 238)",
                },
                {
                  offset: 1,
                  color: "rgb(25, 183, 207)",
                },
              ]),
            },
          },
        ],
      };
      that.myChart5.setOption(option);
    },
    //  金字塔
    initTrapezoid() {
      // let winWidth = window.innerWidth;
      const that = this;
      that.myChart3 = echarts.init(document.getElementById("wzlt"));
      // 定义标题 需根据效果图 来微调
      const img1 = require("@/assets/images/left1.png");
      const img2 = require("@/assets/images/left2.png");
      const img3 = require("@/assets/images/left3.png");
      let option = {
        tooltip: {
          show: true,
          formatter: function (params) {
            console.log("111", params);
            return (
              params.marker + params.name + ":" + params.data.number + "万"
            );
          },
        },
        grid: {
          // containLabel: true,
          // left: '10%',
          top: "19%",
          bottom: "0%",
        },
        xAxis: {
          show: false,
          data: ["", "", "", ""],
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: "#5EA2ED",
            interval: 0,
          },
          axisLine: {
            lineStyle: {
              color: "#1B5BBA",
            },
          },
        },
        yAxis: {
          show: false,
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              color: "#1B5BBA",
            },
          },
          axisLabel: {
            color: "#5EA2ED",
            interval: 0,
          },
        },
        series: [
          {
            type: "pictorialBar",
            //  labelLine:{
            // 	 show:true,
            // 	 length2:20,
            // 	  lineStyle:{
            // 		  color:'red',
            // 		  width:5
            // 	  }

            //  },
            //  label: {
            //          show: true,
            //          position: 'right',
            //          formatter: '{b}{c} 万头',
            //          fontSize: 16,
            //          color: '#e54035',
            // 		 verticalAlign:'top'
            // },
            data: [
              {
                name: "测试1",
                z: 100,
                value: 20,
                number: 123,
                symbolSize: ["150%", "90%"],
                symbolPosition: "center",
                symbolOffset: ["125%", "-265%"],
                symbol: "image://" + img1,
              },
              {
                name: "测试2",
                z: 90,
                value: 40,
                number: 456,
                symbolSize: ["300%", "40%"],
                symbolPosition: "center",
                symbolOffset: ["23%", "-130%"],
                symbol: "image://" + img2,
              },
              {
                name: "测试3",
                z: 80,
                value: 60,
                number: 789,
                symbolSize: ["450%", "35%"],
                symbolPosition: "center",
                symbolOffset: ["-13%", "30%"],
                symbol: "image://" + img3,
              },
            ],
          },
        ],
      };
      that.myChart3.setOption(option);
    },
    // 玩转利通 图表
    initWzltChart() {
      let winWidth = window.innerWidth;
      const that = this;
      that.myChart3 = echarts.init(document.getElementById("wzlt"));
      let option = {
        tooltip: {
          trigger: "axis",
          axisPointer: { type: "shadow" },
        },
        grid: {
          left: "8%",
          right: "8%",
          top: "20%",
          bottom: "20%",
        },
        xAxis: {
          type: "category",
          boundaryGap: true,
          data: ["特色产品", "特色活动", "特色文化", "景区", "农家乐", "美食"],
          // data:dataYears,
          axisLine: {
            lineStyle: {
              color: "#cdfbff",
            },
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              color: "#cdfbff",
              fontSize: winWidth >= 5000 ? 20 : 14,
            },
          },
        },
        yAxis: {
          name: "(个)",
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              color: "#cdfbff",
            },
          },
          axisLabel: {
            textStyle: {
              fontSize: winWidth >= 5000 ? 20 : 14,
              color: "#cdfbff",
            },
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            data: [
              that.statistics.productCount,
              0,
              that.statistics.facilitiesCount,
              that.statistics.viewCount,
              that.statistics.nongjialeCount,
              that.statistics.foodCount,
            ],
            smooth: false,
            type: "bar",
            barWidth: 12,
            // areaStyle: {
            //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            //     {
            //       offset: 0,
            //       color: "rgba(23,95,243,0.9)"
            //     },
            //     {
            //       offset: 1,
            //       color: ""
            //     }
            //   ])
            // }
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff6" },
                  { offset: 0.5, color: "#188df0" },
                  { offset: 1, color: "#188df0" },
                ]),
                barBorderRadius: [10, 10, 0, 0],
                label: {
                  show: true, //开启显示
                  position: "top", //在上方显示
                  textStyle: {
                    //数值样式
                    color: "#FFF",
                    fontSize: 12,
                  },
                  formatter: "{c}个",
                },
              },
            },
          },
        ],
      };
      that.myChart3.setOption(option);
    },
    createMap() {
      let winWidth = window.innerWidth;
      echarts.registerMap("ltq", { geoJSON: ltqMap });
      this.myChart = echarts.init(document.getElementById("map_1"));
      var data = [];
      var geoCoordMap = {};
      var convertData = function (data) {
        var res = [];
        for (var i = 0; i < data.length; i++) {
          var geoCoord = geoCoordMap[data[i].name];
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value),
            });
          }
        }
        return res;
      };
      // let coordinates = JSON.parse(JSON.stringify(ltqMap.features[0].geometry.coordinates[0][0]))
      // let  busLines = [{
      //   coords: coordinates,
      //   lineStyle: {
      //     normal: {
      //       color: echarts.color.modifyHSL('#00D8F4', Math.round(200 * 1))
      //     }
      //   }
      // }];

      var option = {
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            if (typeof params.value[2] == "undefined") {
              return params.name + " : " + params.value;
            } else {
              return params.name + " : " + params.value[2];
            }
          },
        },

        geo: [
          {
            map: "ltq",

            geoIndex: 2,
            label: {
              show: true,
              emphasis: {
                show: false,
              },
              textStyle: {
                color: "#fff",
              },
            },
            zlevel: 2,
            roam: false, //禁止其放大缩小
            itemStyle: {
              normal: {
                areaColor: "rgba(0,0,0,0)",
                borderColor: "rgba(82,255,255,0.8)",
                borderWidth: 2,
                shadowColor: "rgb(0,227,255)",
                shadowBlur: 20,
                shadowOffsetX: -5,
                shadowOffsetY: 6,
                borderCap: "round",
                borderJoin: "round",
              },
              emphasis: {
                areaColor: "rgba(6,32,141,0.2)",
              },
            },
            groundPlane: {
              show: true,
            },
            // left: winWidth >= 5000 ? "40%" : "30%",
            left: winWidth >= 5000 ? "50%" : "20%",
            top: "15%",
          },
          {
            map: "ltq",
            geoIndex: 1,
            // layoutCenter: [winWidth >= 5000 ? '50%' : '20%', "15%"],
            // layoutCenter: winWidth >= 5000 ? ["57%", "55%"] : ["58.1%", "55%"],
            // layoutSize: winWidth >= 5000 ? "80%" : "91%",
            layoutCenter: winWidth >= 5000 ? ["64%", "55%"] : ["50%", "55%"],
            layoutSize: winWidth >= 5000 ? "80%" : "90%",
            zlevel: 1,
            // aspectScale: 1,
            silent: true,
            label: {
              emphasis: {
                show: false,
              },
            },
            roam: false, // 是否允许缩放
            itemStyle: {
              borderColor: "rgba(63, 218, 255, 0)",
              areaColor: {
                image: this.$refs.mapSvgAreaMap, // 支持为 HTMLImageElement, HTMLCanvasElement，不支持路径字符串
                repeat: "repeat", // 是否平铺, 可以是 'repeat-x', 'repeat-y', 'no-repeat'
              },
            },
            groundPlane: {
              show: true,
            },
          },
        ],
        series: [
          {
            type: "scatter",
            coordinateSystem: "geo",
            data: convertData(data),
            barWidth: 100,
            symbolSize: function (val) {
              return val[2] / 15;
            },
            label: {
              normal: {
                formatter: "{b}",
                position: "right",
                show: false,
              },
              emphasis: {
                show: true,
              },
            },
            itemStyle: {
              color: "rgb(20, 15, 2)",
              borderWidth: 10,
              borderColor: "#FFF",
            },
          },
          // {
          //   type: 'lines',
          //   coordinateSystem: 'geo',
          //   polyline: true,
          //   data: busLines,
          //   silent: true,
          //   lineStyle: {
          //     opacity: 0.2,
          //     width: 1
          //   },
          //   progressiveThreshold: 1000,
          //   progressive: 500
          // },
          // {
          //   type: 'lines',
          //   coordinateSystem: 'geo',
          //   polyline: true,
          //   data: busLines,
          //   lineStyle: {
          //     width: 0
          //   },
          //   effect: {
          //     constantSpeed: 60,
          //     show: true,
          //     trailLength: 0.5,
          //     symbol: 'circle',
          //     symbolSize: 6,
          //     color: '#00ff8c'
          //   },
          //   zlevel: 1
          // }
        ],
      };
      setTimeout(() => {
        this.myChart.setOption(option);
      }, 1000);
      const that = this;
      window.addEventListener("resize", () => {
        that.myChart.resize();
      });
    },
    initChart() {
      let winWidth = window.innerWidth;
      const that = this;
      that.myChart2 = echarts.init(document.getElementById("chart1"));
      let dataName = []; //产业
      let dataYears = []; //x-年
      let dataProfit = []; //y-数值
      let dataProfit2 = []; //y-数值
      let dataProfit3 = []; //y-数值
      api
        .getProfitList({
          pageNum: 1,
          pageSize: 99,
        })
        .then((res) => {
          // console.log("地区生产总值",res)
          let grossDomesticProduct = res.rows;
          grossDomesticProduct.forEach((v) => {
            dataName.push(v.productName);
            dataYears.push(v.years);
            if (v.productName == "第一产业") {
              dataProfit.push(v.profit);
            }
            if (v.productName == "第二产业") {
              dataProfit2.push(v.profit);
            }
            if (v.productName == "第三产业") {
              dataProfit3.push(v.profit);
            }
          });
          let option = {
            tooltip: {
              trigger: "axis",
              axisPointer: { type: "shadow" },
            },
            grid: {
              top: winWidth >= 5000 ? 15 : 40,
              bottom: winWidth >= 5000 ? 15 : 20,
            },
            legend: {
              top: "0",
              right: "10%",
              data: ["第一产业", "第二产业", "第三产业"],
              // data: dataName,
              itemWidth: winWidth >= 5000 ? 30 : 20,
              itemHeight: winWidth >= 5000 ? 15 : 10,
              textStyle: {
                fontSize: winWidth >= 5000 ? 20 : 14,
                color: "#cdfbff",
              },
            },
            xAxis: {
              type: "category",
              data: [2016, 2017, 2018, 2019, 2020, 2021, 2022],
              // data:dataYears,
              axisLine: {
                lineStyle: {
                  color: "#FFF",
                },
              },
              axisLabel: {
                interval: 0,
                textStyle: {
                  fontSize: winWidth >= 5000 ? 20 : 14,
                  color: "#cdfbff",
                },
              },
            },
            yAxis: {
              name: "(万)",
              type: "value",
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#FFF",
                },
              },
              axisLabel: {
                textStyle: {
                  fontSize: winWidth >= 5000 ? 20 : 14,
                  color: "#cdfbff",
                },
              },

              splitLine: {
                show: false,
              },
            },
            series: [
              {
                name: "第一产业",
                //data: [10, 20, 30, 40, 70, 60, 70],
                data: dataProfit,
                barWidth: winWidth >= 5000 ? 20 : 12,
                type: "line",
                itemStyle: {
                  normal: {
                    label: {
                      show: true, //开启显示
                      position: "top", //在上方显示
                      textStyle: {
                        //数值样式
                        color: "#cdfbff",
                        fontSize: 12,
                      },
                      formatter: "{c}万",
                    },
                  },
                },
              },
              {
                name: "第二产业",
                //data: [120, 200, 150, 80, 70, 110, 130],
                data: dataProfit2,
                barWidth: winWidth >= 5000 ? 20 : 12,
                type: "line",
                itemStyle: {
                  normal: {
                    label: {
                      show: true, //开启显示
                      position: "top", //在上方显示
                      textStyle: {
                        //数值样式
                        color: "#FFF",
                        fontSize: 12,
                      },
                      formatter: "{c}万",
                    },
                  },
                },
              },
              {
                name: "第三产业",
                //data: [1, 25, 36, 48, 55, 99, 63],
                data: dataProfit3,
                barWidth: winWidth >= 5000 ? 20 : 12,
                type: "line",
                itemStyle: {
                  normal: {
                    label: {
                      show: true, //开启显示
                      position: "top", //在上方显示
                      textStyle: {
                        //数值样式
                        color: "#FFF",
                        fontSize: 10,
                      },
                      formatter: "{c}万",
                    },
                  },
                },
              },
            ],
          };
          that.myChart2.setOption(option);
        });
      window.addEventListener("resize", () => {
        let winWidth = window.innerWidth;
        that.myChart2.setOption({
          xAxis: {
            axisLabel: {
              textStyle: {
                fontSize: winWidth >= 5000 ? 20 : 14,
              },
            },
          },
          yAxis: {
            axisLabel: {
              textStyle: {
                fontSize: winWidth >= 5000 ? 20 : 14,
              },
            },
          },
          series: [
            {
              barWidth: winWidth >= 5000 ? 20 : 20,
            },
          ],
        });
        that.myChart2.resize();
      });
    },
  },
};
</script>

<style scoped lang="scss">
.industry {
  height: 100%;
  display: flex;
  justify-content: space-between;

  .industry-box {
    box-shadow: 0 0 30px 0 rgba(0, 128, 202, 0.8) inset;
    height: 100%;
    border-radius: 0.02rem;
    position: relative;
    overflow: hidden;
  }

  .industry-left {
    width: 40%;
    padding: 0.1rem;
    display: flex;
    flex-wrap: wrap;

    .industry-left-top {
      width: calc(33.3% - 0.1rem) !important;
      height: calc(33.3% - 0.05rem) !important;
      margin-bottom: 0.1rem;
      margin-right: 0.1rem;
    }

    .industry-left-right {
      width: calc(33.3% - 0.1rem) !important;
      height: calc(33.3% - 0.05rem) !important;
      margin-right: 0.1rem !important;
    }

    .industry-left-right-right {
      width: calc(33.3% - 0.1rem);
      height: calc(33.3% - 0.05rem) !important;
      margin-bottom: 0.1rem;
      margin-right: 0.1rem;
    }

    .industry-left-bottom-left {
      // width: calc(100%);
      width: calc(33.3% - 0.1rem);
      height: calc(33.3% - 0.05rem);
      margin-bottom: 0.1rem;
      margin-right: 0.1rem;
    }

    .industry-left-bottom-center {
      // width: calc(100%);
      width: calc(33.3% - 0.1rem);
      height: calc(33.3% - 0.05rem);

      margin-right: 0.1rem;
    }

    .industry-left-bottom-right {
      // width: calc(100%);
      width: calc(33.3% - 0.1rem);
      height: calc(33.3% - 0.05rem);
      margin-right: 0.1rem;
    }
  }

  .xflt-right {
    width: 100%;
    height: 100%;

    .yqtjRight-itembox-image {
      position: relative;

      .yqtjRight-itembox-text {
        position: absolute;
        bottom: 0;
        width: 100%;
        left: 0;
        height: 0.3rem;
        background: rgba(0, 0, 0, 0.5);
        color: #fff;
        line-height: 0.3rem;
        font-size: 0.14rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        word-break: break-all;
        -webkit-box-orient: vertical;
      }
    }
  }

  .industry-zsys {
    padding: 0.1rem;
    height: calc(100% - 0.2rem);

    .zsys-box {
      display: flex;
      align-items: center;
      justify-content: space-between;

      div {
        flex: 1;
      }
    }

    .industry-zsys-title {
      margin-bottom: 0.3rem;
      padding-left: 0.1rem;
      font-size: 0.12rem;
      color: #b4e6ff;
      font-weight: bold;
      display: flex;
      align-items: center;
      position: relative;

      .left-img {
        position: absolute;
        top: 0.05rem;
        left: 0;
        width: 50%;
      }

      .right-img {
        position: absolute;
        top: 0.05rem;
        right: 0;
        width: 50%;
      }

      div {
        width: 100%;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, 0);
        text-align: center;
      }
    }

    .content-img {
      width: 100%;
      height: calc(100% - 0.4rem);
    }

    .xflt-box {
      display: flex;
      justify-content: space-around;
      height: calc(100% - 0.35rem);

      .xflt-box-item {
        width: 33%;
        text-align: center;
        font-size: 0;
        position: relative;

        img {
          position: absolute;
          bottom: 0.05rem;
          left: calc(50% - 0.38rem);
          width: 0.76rem;
        }

        div {
          position: absolute;
          font-size: 0.1rem;
          color: #fff;

          span {
            font-size: 0.16rem;
            font-weight: bold;
          }
        }

        .wsy-all {
          width: 100%;
          text-align: center;
        }

        .yly-all {
          bottom: 2rem;
          width: 100%;
          text-align: center;
        }

        .ggwhss-all {
          bottom: 1.58rem;
          width: 100%;
          text-align: center;
        }

        .wsy {
          position: absolute;
          font-size: 0.1rem;
          bottom: 0.5rem;
          font-weight: bold;
          left: 0.35rem;
          color: #96dbff;
        }

        .yy {
          position: absolute;
          font-size: 0.1rem;
          bottom: 0.5rem;
          font-weight: bold;
          left: 0.35rem;
          color: #96dbff;
        }

        .yly {
          position: absolute;
          font-size: 0.1rem;
          bottom: 0.5rem;
          font-weight: bold;
          left: 0.35rem;
          color: #94ffe2;
        }

        .ggwhss {
          position: absolute;
          font-size: 0.1rem;
          bottom: 0.5rem;
          font-weight: bold;
          left: 0.3rem;
          color: #ccaaff;
        }
      }
    }

    .industry-zsys-body3 {
      height: calc(100% - 0.5rem);

      ::v-deep .dv-scroll-board .rows .ceil {
        font-size: 0.11rem;
        color: #cdfbff;
      }
    }

    .industry-zsys-body2 {
      height: calc(100% - 0.5rem);
      font-size: 0.165rem;
      color: #fff;
      display: flex;
      justify-content: center;

      .industryZsys-item {
        width: 27%;
        margin: 0 0.1rem;
        text-align: center;

        div:nth-of-type(1) {
          margin: 0.2rem 0 0.5rem;
          font-size: 0.4rem;
          font-weight: bold;
        }
      }

      .industryZsys-item-blue {
        color: #80e6ff;
        background: url("../assets/images/zszy_blue.png") no-repeat;
        background-size: 100%;
        background-position-y: 50%;
      }

      .industryZsys-item-orange {
        color: #ffba69;
        background: url("../assets/images/zszy_orange.png") no-repeat;
        background-size: 100%;
        background-position-y: 50%;
      }

      .industryZsys-item-red {
        color: #f27575;
        background: url("../assets/images/zszy_red.png") no-repeat;
        background-size: 100%;
        background-position-y: 50%;
      }
    }
  }

  .industry-center {
    width: 30%;
    padding: 0.1rem;
    position: relative;
    margin: 0.05rem 0;

    // background: url("../assets/images/cyzsl_bg.png") no-repeat;
    // background-size: 100% 100%;
    .total-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.12rem;
      color: #fff;
      text-align: center;

      .total-item {
        display: flex;
        flex-flow: column;
        align-content: center;
        position: relative;
        flex: 1;
        margin: 0.5rem 0.1rem 0.1rem 0.1rem;
        padding: 0.2rem 0;

        .item-top {
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(-50%, 0);
          white-space: nowrap;
        }

        .item-text {
          position: absolute;
          top: 0.3rem;
          left: 50%;
          white-space: nowrap;
          transform: translate(-50%, 0);
        }

        img {
          width: 100%;
          height: 70%;
          position: absolute;
          top: 0.45rem;
          left: 50%;
          transform: translate(-50%, 0);
        }
      }
    }

    .video-box {
      height: calc(100% - 3rem);
      margin: auto auto;
      // width: calc(100% - 4rem);
      display: flex;
      align-items: center;
      position: relative;
      z-index: 1;

      .video-player {
        width: 100%;
        padding: 0.2rem;
        box-shadow: 0 0 30px 0 rgb(0 128 202 / 80%) inset;

        ::v-deep .video-js {
          width: 100% !important;
          height: auto !important;
        }

        ::v-deep .vjs-big-play-button {
          left: calc(50% - 45px);
          top: calc(50% - 20px);
        }
      }
    }

    .center-zsys-title {
      position: absolute;
      width: 100%;
      text-align: center;
      font-size: 0.1rem;
      font-weight: bold;
      color: #a7dbff;
      top: 0;
    }

    .center-zsr {
      position: absolute;
      top: 0.25rem;
      left: calc(50% - 0.9rem);
      font-size: 0.1rem;
      color: #fff;

      span {
        display: inline-block;
        font-size: 0.2rem;
        background: url("../assets/images/zsl_bg.png") no-repeat;
        height: 0.3rem;
        line-height: 0.3rem;
        width: 0.2rem;
        text-align: center;
        margin: 0 0.02rem;
      }
    }

    .center-xzxx {
      position: absolute;
      z-index: 1001;
      top: 0.7rem;
      left: 0.2rem;
      height: calc(100% - 2rem);
    }

    .center-xzxx-item {
      width: 1rem;
      background: url("../assets/images/xzxx_bg.png") no-repeat;
      box-sizing: border-box;
      background-size: 100% 100%;
      padding: 0.1rem;
      color: #00ffff;
      text-align: center;

      div:nth-of-type(1) {
        font-size: 0.1rem;
        margin: 0.06rem 0;
      }

      div:nth-of-type(2) {
        font-size: 0.1rem;

        span {
          font-size: 0.16rem;
        }
      }
    }

    .center-xzxx2 {
      position: absolute;
      z-index: 1001;
      top: 0.7rem;
      right: 0.2rem;
      height: calc(100% - 1rem);
    }

    .map {
      position: relative;
      height: 100%;
      overflow: hidden;
    }
  }

  .industry-right {
    width: 40%;
    // padding: 0.1rem;
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    // box-shadow: 0 0 30px 0 rgb(0 128 202 / 80%) inset;

    margin: 0.1rem;

    .right-top-title {
      text-align: center;
      color: #fff;
      font-size: 0.2rem;
      width: 100%;
      height: 0.3rem;
      padding: 0.05rem 0;
      box-shadow: 0 0 30px 0 #09375e inset;
    }

    .right-top-content-wrap {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      font-size: 0.15rem;
      color: #fff;
      // height: calc(100% - 0.6rem);

      margin-top: 0.2rem;

      .right-top-wrap-item {
        width: calc(50% - 0.4rem);
        margin: 0.2rem 0.1rem;
        // padding: 0.5rem 0;
        height: 1.5rem;
        padding: 0.1rem;
        // box-shadow: 0 0 30px 0 rgba(0, 128, 202, 0.8) inset;
        background: url("@/assets/images/park-bg.png") no-repeat;
        background-size: 100% 100%;

        .item-title {
          padding: 0.1rem;
        }

        .item-content {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          word-break: break-all;
          -webkit-box-orient: vertical;
          padding: 0 0.1rem;
          line-height: 1.5;

          span {
            color: #c00406;
            padding: 0 0.1rem;
          }
        }
      }
    }

    .industry-right-box {
      width: calc(50% - 0.05rem);
    }

    .industry-right-top {
      width: calc(100% - 0.05rem);
      height: calc(50% - 0.05rem);
      margin-bottom: 0.1rem;
    }

    .industry-right-right {
      width: calc(100% - 0.05rem);
      height: calc(50% - 0.05rem);
      margin-bottom: 0.1rem;
    }

    .industry-left-bottom {
      width: calc(100% - 0.05rem);
      margin-bottom: 0.1rem;
      height: calc(100% - 1.89rem);
    }

    .industry-right-bottom {
      width: calc(100% - 0.05rem);
      height: 1.59rem;
      box-sizing: border-box;

      .industry-box {
        padding: 0.1rem;
      }
    }
  }
}

@media screen and (max-width: 1920px) {
  .industry {
    .industry-zsys {
      .xflt-box {
        .xflt-box-item {
          .wsy {
            left: 0.55rem;
          }

          .yly {
            left: 0.55rem;
          }

          .ggwhss {
            left: 0.48rem;
          }

          .yy {
            left: 0.6rem;
          }
        }

        .xflt-box-item:nth-of-type(2) {
          .yly-all {
            bottom: 1.7rem;
          }
        }
      }
    }

    .industry-center {
      width: 40%;

      .center-zsr {
        top: 0.5rem;
      }

      .center-xzxx {
        top: 1.6rem;
      }

      .center-xzxx2 {
        top: 1.6rem;
      }
    }

    .industry-left {
      width: 30%;

      .industry-left-top {
        width: 100%;
        height: 25%;
        padding: 0;
        // margin: 0;
      }

      .industry-left-right {
        width: 100%;
        height: calc(50% - 0.2rem);
        // margin: 0.1rem 0;
      }

      .industry-left-bottom {
        width: 100%;
        height: 25%;
        padding: 0;
        margin: 0;
      }
    }

    .industry-right {
      width: 30%;

      .industry-right-box {
        width: 100%;
        height: 50%;

        .industry-right-top {
          margin: 0 0 0.1rem 0;
        }

        .industry-right-right {
          height: calc(50% - 0.05rem);
        }

        .industry-left-bottom {
          height: calc(50% - 0.2rem);
          margin: 0.1rem 0;
        }

        .industry-right-bottom {
          height: 50%;

          .industry-box {
            box-sizing: border-box;

            .xflt-right {
              .yqtjRight-itembox-image {
                height: 100%;

                img {
                  height: 100%;
                }
              }
            }
          }
        }
      }
    }
  }
}

.businessTree {
  .tree-div {
    height: 350px;
    position: relative;
  }

  .tree-title {
    background: url("~@/assets/images/xflt1.png") no-repeat;
    background-size: 100% 100%;
    width: 0.5rem;
    // line-height: 35PX;
    text-align: center;
    font-size: 0.1rem;
    color: #fff;

    .name {
      color: #4aa2cc;
      // margin-right: 0.5rem;
      font-size: 0.1rem;
    }

    .number {
      color: #a86d3c;
      font-weight: bold;
      font-size: 0.1rem;
      //font-style: oblique;
    }
  }

  .tree-title0 {
    position: absolute;
    top: 0.05rem;
    left: 1.1rem;
  }

  .tree-title1 {
    position: absolute;
    top: 0.6rem;
    right: 0.1rem;
  }

  .tree-title2 {
    position: absolute;
    top: 1.8rem;
    left: 0.1rem;
  }
}
</style>
